import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Instagram, MapPin } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Reveal";
import { PROJECTS } from "@/data/projects";
import { SITE } from "@/lib/site";

export const ProjectCard = ({ p, i = 0 }) => (
  <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: (i % 3) * 0.08 }}>
    <Link to={`/projects#${p.id}`} data-testid={`project-${p.id}`} className="group block">
      <div className="relative aspect-[4/5] overflow-hidden bg-ink clip-notch-sm">
        <img src={p.image} alt={`${p.title} – Austyle Plumbing`} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-transparent" />
        <span className="absolute top-5 left-5 inline-flex items-center gap-1.5 bg-porcelain/95 text-ink text-xs font-bold px-3 py-1.5 rounded-full"><MapPin className="h-3.5 w-3.5 text-cobalt" />{p.suburb}</span>
        <span className="absolute top-5 right-5 font-mono text-[11px] text-white bg-ink/60 px-2.5 py-1 rounded-full">{p.gallery.length} photos</span>
        <div className="absolute bottom-0 inset-x-0 p-6 text-white">
          <h3 className="font-wide font-extrabold text-xl sm:text-2xl leading-tight">{p.title}</h3>
          <p className="mt-2 text-sm text-slate-200 leading-relaxed">{p.note}</p>
        </div>
      </div>
    </Link>
  </motion.div>
);

export const Projects = () => (
  <section data-testid="projects-section" className="bg-porcelain py-24 sm:py-32">
    <div className="container-x">
      <div className="grid gap-8 lg:grid-cols-12 items-end mb-14">
        <div className="lg:col-span-8">
          <Reveal><p className="eyebrow text-cobalt mb-5">Recent projects</p></Reveal>
          <h2 className="font-wide font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            <MaskLines lines={["Real work.", "Real Sydney homes."]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-4" delay={0.15}>
          <p className="text-slate-600 leading-relaxed">Finished bathrooms, kitchens and homes our team has completed across Sydney.</p>
          <div className="mt-5 flex flex-wrap gap-5">
            <Link to="/projects" data-testid="projects-view-all" className="inline-flex items-center gap-2 font-bold text-cobalt link-underline">View all projects <ArrowUpRight className="h-4 w-4" /></Link>
            <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="projects-instagram-link" className="inline-flex items-center gap-2 font-bold text-cobalt link-underline"><Instagram className="h-4 w-4" />Instagram</a>
          </div>
        </Reveal>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {PROJECTS.slice(0, 4).map((p, i) => <ProjectCard key={p.id} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
